var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-grid__item\tm-aside-left  m-aside-left--skin-light ",attrs:{"id":"m_aside_left"}},[_c('div',{staticClass:"m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark ",attrs:{"id":"m_ver_menu","data-menu-vertical":"true","data-menu-scrollable":"false","data-menu-dropdown-timeout":"500"}},[(_vm.services)?_c('services-nav'):_c('dashboard-nav')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749e472e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/SideBar.vue
// module id = null
// module chunks = 